import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { FooterService } from '../footer.service';
@Component({
  selector: 'app-sell-product',
  templateUrl: './sell-product.component.html',
  styleUrls: ['./sell-product.component.css']
})
export class SellProductComponent implements OnInit, OnDestroy {

  chekoutArray: any[] = [];
  getRetailProducts: any = [];
  model: any;
  buyingProducts: any = [];
  brands: any;
  search: any = [];
  services: any;
  products: any;
  tot_amt: number = 0;
  EMPS: any;
  currentUser: any;
  showMobileCart: boolean = false;

  constructor(
    private router: Router,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService,
    private footerService: FooterService

  ) {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    let date = this.loginservice.getCurrentDateString();
    this.chekoutArray = [];
    if (this.loginservice.getLocalSession('model') === null) {
      this.router.navigate(['billings']);
    } else {
      this.model = JSON.parse(this.loginservice.getLocalSession('model'));
    }


    this.loginservice.getemp('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.EMPS = data['comp_details'];
        } else {
          this.EMPS = [];
        }
      }, error => { alert('Network Error getemp API'); });
  }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.search = {
      brand: '',
      service: '',
      product: ''
    };
    this.getRetailProduct();
    this.getBrand();
    this.getINVService();
    this.getProduct();
  }

  ngOnDestroy() {
    this.footerService.showFooter();
  }

  getRetailProduct() {
    this.loginservice.getRetailProduct(this.search, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.getRetailProducts = data['data'];
            this.getRetailProducts.forEach((covenant: any) => {
              if (covenant.service) {
                covenant.service.forEach((item: any) => {
                  if (item.list) {
                    item.list.forEach((product: any) => {
                      product.checked = false; // Initialize 'checked' property
                      product.emp_id = this.model['employee_id'];
                      if (this.buyingProducts.length > 0) {
                        this.buyingProducts.forEach(element => {
                          if (element.id == product.id) {
                            product.checked = true;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          } else {
            this.getRetailProducts = [];
          }
        }, error => { alert('Network Error getRetailProduct API'); });
  }

  getBrand() {
    this.loginservice.getBrand(this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.brands = data['data'];
          } else {
            this.brands = [];
          }
        }, error => { alert('Network Error getBrand API'); });
  }

  getINVService() {
    this.loginservice.getINVService(this.currentUser).subscribe(data => {
      this.services = data['data'];
    }, error => { alert('Network Error getINVService API'); });
  }

  getProduct() {
    this.loginservice.getProduct(this.currentUser).subscribe(data => {
      this.products = data['data'];
    }, error => { alert('Network Error getProduct API'); });
  }




  getKeyValues(obj: any): { key: string, value: any[] }[] {
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }

  // getcheckoutNew() {
  //   this.loginservice.getcheckoutNew(this.model).subscribe(
  //     data => {

  //     });
  // }

  // chekspack1(product, index, addMinus) {
  //   if (addMinus == '1') {

  //     let quantity = 0;
  //     this.buyingProducts.forEach(element => {
  //       quantity = 1;
  //       if (element.id == product.id) {
  //         if (element.customer_usage <= element.quantity_on_sales_order) {
  //           alert('Stock Is Not Available. Quantity On Hand Is ' + element.customer_usage)
  //         } else {
  //           element.quantity_on_sales_order = parseInt(element.quantity_on_sales_order) + quantity
  //           element.totalCost = parseInt(element.quantity_on_sales_order) * parseInt(element.amt_per);
  //         }
  //       }
  //     });
  //   } else {
  //     this.buyingProducts.forEach(element => {
  //       if (element.id == product.id) {

  //         if (element.quantity_on_sales_order <= 1) {
  //           // alert('Stock Is Not Available. Quantity On Hand Is ' + element.quantity_on_hand)
  //         } else {
  //           element.quantity_on_sales_order = parseInt(element.quantity_on_sales_order) - 1;
  //           element.totalCost = parseInt(element.quantity_on_sales_order) * parseInt(element.amt_per);
  //         }
  //       }
  //     });
  //   }
  //   this.calculateTotalAmt()
  // }



  // buy(product, index) {
  //   const productCopy = product;
  //   if (product.checked) {
  //     if (this.buyingProducts.length > 0) {
  //       const existingIndex = this.buyingProducts.findIndex(elem => elem.id === productCopy.id);
  //       if (existingIndex !== -1) {
  //         this.buyingProducts[existingIndex].quantity_on_sales_order = 1;
  //         this.buyingProducts[existingIndex].totalCost = parseInt(this.buyingProducts[existingIndex].quantity_on_sales_order) * parseInt(this.buyingProducts[existingIndex].amt_per);
  //         this.buyingProducts.splice(existingIndex, 1);
  //       }
  //     }
  //   } else {
  //     const existingIndex = this.buyingProducts.findIndex(elem => elem.id === productCopy.id);
  //     if (existingIndex !== -1) {
  //       this.buyingProducts[existingIndex].quantity_on_sales_order = 1;
  //       this.buyingProducts[existingIndex].totalCost = parseInt(this.buyingProducts[existingIndex].quantity_on_sales_order) * parseInt(this.buyingProducts[existingIndex].amt_per);
  //       // this.buyingProducts.splice(existingIndex, 1);
  //       this.chekspack1(productCopy, index, '1');
  //     } else {
  //       if (productCopy.quantity_on_sales_order <= 0) {
  //         productCopy.quantity_on_sales_order = 1;
  //       }
  //       productCopy.totalCost = parseInt(productCopy.quantity_on_sales_order) * parseInt(productCopy.amt_per);

  //       this.EMPS.forEach(element => {
  //         if (element.id == productCopy['emp_id']) {
  //           productCopy['emp_name'] = element.f_name;
  //         }
  //       });


  //       this.buyingProducts.push(productCopy);
  //     }
  //   }
  //   this.calculateTotalAmt()
  // }


  chekspack1(product, index, addMinus) {
    const quantity = 1;
    let productFound = false;
    let productToUpdate = null;
    let qoso = 0; // Use `let` instead of `const` here
    // Use a single loop to find and handle product updates
    for (const element of this.buyingProducts) {
      if (element.id === product.id) {
        if (addMinus === '1') {
          qoso += element.quantity_on_sales_order; // Update qoso when a matching product is found
          // Check stock availability
          if (element.customer_usage <= qoso) {
            alert('Stock Is Not Available. Quantity On Hand Is ' + element.customer_usage);
            return; // Stop further execution of the function
          }
          // Update existing product if emp_id matches
          if (element.emp_id === product.emp_id) {
            productToUpdate = element;
            productFound = true;
            // break;
          }
        } else if (addMinus !== '1') {
          // Find the product to update if removing
          if (element.emp_id === product.emp_id) {
            productToUpdate = element;
            productFound = true;
            break;
          }
        }
      }
    }

    if (addMinus === '1') {
      if (productToUpdate) {
        // Update quantity and total cost for matching product
        productToUpdate.quantity_on_sales_order = parseInt(productToUpdate.quantity_on_sales_order) + quantity;
        productToUpdate.totalCost = parseInt(productToUpdate.quantity_on_sales_order) * parseInt(productToUpdate.amt_per);
      } else {
        // If no matching product found, add a new one
        const productCopy = { ...product, quantity_on_sales_order: 1, totalCost: parseInt(product.amt_per) };
        this.EMPS.forEach(emp => {
          if (emp.id === productCopy.emp_id) {
            productCopy.emp_name = emp.f_name;
          }
        });
        this.buyingProducts.push(productCopy);
      }
    } else {
      if (productToUpdate && productToUpdate.quantity_on_sales_order > 1) {
        // Update quantity and total cost for matching product
        productToUpdate.quantity_on_sales_order = parseInt(productToUpdate.quantity_on_sales_order) - 1;
        productToUpdate.totalCost = parseInt(productToUpdate.quantity_on_sales_order) * parseInt(productToUpdate.amt_per);
      }
    }

    this.calculateTotalAmt();
  }

  buy(product, index) {
    if (product.checked) {
      const productId = product.id;
      // Use filter to create a new array excluding all items with the same id
      this.buyingProducts = this.buyingProducts.filter(elem => elem.id !== productId);
    } else {
      const existingIndex = this.buyingProducts.findIndex(elem => elem.id === product.id);
      if (existingIndex === -1) {
        // Create a deep copy of the product object to avoid reference issues
        const productCopy = { ...product, emp_id: product.emp_id, emp_name: '', totalCost: 0 };
        if (productCopy.quantity_on_sales_order <= 0) {
          productCopy.quantity_on_sales_order = 1;
        }
        productCopy.totalCost = parseInt(productCopy.quantity_on_sales_order) * parseInt(productCopy.amt_per);
        this.EMPS.forEach(element => {
          if (element.id === productCopy.emp_id) {
            productCopy.emp_name = element.f_name;
          }
        });
        this.buyingProducts.push(productCopy); // Add the copied product to the list
      }
    }
    this.calculateTotalAmt();
  }


  calculateTotalAmt() {
    this.tot_amt = 0;
    if (this.buyingProducts.length > 0) {
      this.buyingProducts.forEach(element => {
        this.tot_amt += parseInt(element['totalCost']);
      });
    } else {
      this.tot_amt = 0;
    }
  }

  save() {
    if (window.innerWidth <= 768) {
      this.showMobileCart = true;
      return;
    }
    this.proceedToCheckout();
  }

  proceedToCheckout() {
    this.showMobileCart = false;
    this.router.navigate(['checkout'], {
      queryParams: {
        tot_amt: JSON.stringify(this.tot_amt),
        search: JSON.stringify(this.search),
        model: JSON.stringify(this.model),
        buyingProducts: JSON.stringify(this.buyingProducts),
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/sell-product/sell-product.component.ts